import React from "react";
import { CheckCircle } from "lucide-react";
import type { FormData } from "../types";
import type { SlideStyleOption } from "../SlideTemplates";

interface SlideStyleSectionProps {
  formData: FormData;
  onFormChange: (field: keyof FormData, value: any) => void;
  slideStyleOptions: SlideStyleOption[];
}

const SlideStyleSection: React.FC<SlideStyleSectionProps> = ({
  formData,
  onFormChange,
  slideStyleOptions,
}) => {
  return (
    <div className="md:col-span-2">
      <label className="block text-sm font-medium mb-3 text-(--text-secondary)">
        Estilo dos Slides *
      </label>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {slideStyleOptions.map((style) => {
          const Icon = style.icon;
          return (
            <button
              key={style.value}
              type="button"
              onClick={() => onFormChange("slideStyle", style.value)}
              className={`p-5 rounded-xl border-2 transition flex flex-col items-center gap-3 relative overflow-hidden group ${
                formData.slideStyle === style.value
                  ? "border-blue-500 bg-blue-50 dark:bg-blue-900/20 shadow-lg scale-105"
                  : "border-(--border-color) hover:border-blue-300 bg-(--card-bg) hover:shadow-md"
              }`}
            >
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center transition-transform group-hover:scale-110 ${
                  formData.slideStyle === style.value ? "shadow-md" : ""
                }`}
                style={{
                  backgroundColor:
                    formData.slideStyle === style.value
                      ? style.color
                      : `${style.color}20`,
                }}
              >
                <Icon
                  className="w-6 h-6"
                  style={{
                    color:
                      formData.slideStyle === style.value
                        ? "white"
                        : style.color,
                  }}
                />
              </div>
              <div className="text-center">
                <span
                  className="text-sm font-bold block mb-1"
                  style={{
                    color:
                      formData.slideStyle === style.value
                        ? style.color
                        : "var(--text-primary)",
                  }}
                >
                  {style.label}
                </span>
                <span className="text-xs text-(--text-tertiary) leading-tight">
                  {style.description}
                </span>
              </div>
              {formData.slideStyle === style.value && (
                <div className="absolute top-2 right-2">
                  <CheckCircle
                    className="w-5 h-5"
                    style={{ color: style.color }}
                  />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SlideStyleSection;
